import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { FormControl } from '@angular/forms'
import { Angulartics2 } from 'angulartics2'

import { MapsAPILoader, GoogleMapsAPIWrapper, LatLngBounds } from '@agm/core'

import { AuthService } from '../../auth/auth.service'
import { UserService, UserLocationService } from '../../users/users.module'

@Component({
  selector: 'cm-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.css'],
  providers: [GoogleMapsAPIWrapper]
})
export class LocationComponent implements OnInit {

  latitude: number
  longitude: number
  zoom: number

  constructor(private loader: MapsAPILoader,
    private wrapper: GoogleMapsAPIWrapper,
    private angulartics2: Angulartics2,
    private authService: AuthService,
    private userService: UserService,
    private userLocationService: UserLocationService,
    private router: Router) {

    this.latitude = 45.55799439258627
    this.longitude = -73.54851007461548
    this.zoom = 17
  }

  ngOnInit() {
    this.getCurrentLocation()

    this.loader.load().then(() => {
      const autocompleteInput = document.getElementById('autocompleteInput') as HTMLInputElement
      const autocomplete = new google.maps.places.Autocomplete(autocompleteInput)

      google.maps.event.addListener(autocomplete, 'place_changed', () => {
          const place = autocomplete.getPlace()

          if (place.geometry) {
            const lat = place.geometry.location.lat()
            const lng = place.geometry.location.lng()

            if (this.latitude !== lat || this.longitude !== lng) {
              this.latitude = lat
              this.longitude = lng
              this.zoom = 17
            }
          }
      })
    })
  }

  onMapClicked(event: any) {
    this.latitude = event.coords.lat
    this.longitude = event.coords.lng
  }

  private getCurrentLocation() {
    const uid = this.authService.currentUser.uid

    this.userService.getUserLocation(uid)
      .then((latLng: number[]) => {
        this.latitude = latLng[0]
        this.longitude = latLng[1]
        this.zoom = 17;
      })
  }

  public saveLocation() {
    const uid = this.authService.currentUser.uid
    this.userService.updatePreferences(uid, {
      follow: false
    })

    this.userLocationService.setLocation(uid, this.latitude, this.longitude).subscribe()
    // this.userLocationService.setLocation(uid, this.latitude, this.longitude)

    this.angulartics2.eventTrack.next({ action: 'change', properties: { category: 'location' } })

    this.router.navigate(['/settings'])
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/location/location.component.ts